import { Space } from 'antd';
import { Controller } from 'react-hook-form';
import { EditOrganizationFormValues } from '../../../../../../../../types/organizationform';
import CustomField from '../../../../../../../components/CustomField';
import { customFieldTypeMap } from '../../../../../../../components/CustomField/CustomField.type';
import { usePaginatedOrganizationFieldDefinitionListOnlyStatusParam } from '../../../../../../../hooks/useOrganizationFieldDefinitionList';
import { USER_FORM_FIELDS_KEY } from '../../../../../../../model/types';
import { getValidationRules } from '../../../../../../../utils/forms/formHelper.validators';
import { generateReactHookFormFriendlyFieldNameWithoutFields } from '../../../AgentFormActiveFieldsContainer';

export const MIN_FIELD_ARRAY_LENGTH = 2; // [ts.requester, ts.assignee]

const generateReactHookFormFriendlyFieldName = (fieldKey: string): any =>
    `${USER_FORM_FIELDS_KEY}.${fieldKey.replace(new RegExp('\\.', 'gi'), '$')}`;

const CustomOrganizationFieldsContainer = ({ isActive }: { isActive: boolean }) => {
    const { data: fields } = usePaginatedOrganizationFieldDefinitionListOnlyStatusParam(true);

    return (
        <Space direction="vertical" className="full-width" size="small">
            {fields?.list?.content?.map((fieldDefinition) => {
                return (
                    <Controller<EditOrganizationFormValues>
                        key={fieldDefinition.key}
                        name={generateReactHookFormFriendlyFieldName(fieldDefinition.key)}
                        render={({
                            field: { value, onChange },
                            fieldState: { error },
                            formState: { defaultValues }
                        }) => {
                            return (
                                <CustomField
                                    {...(fieldDefinition.type === customFieldTypeMap.CHECKBOX
                                        ? {
                                              checkboxDefaultValue:
                                                  defaultValues['fields'][
                                                      generateReactHookFormFriendlyFieldNameWithoutFields(
                                                          fieldDefinition.key
                                                      )
                                                  ]?.toString()
                                          }
                                        : {})}
                                    // defaultValue={null}
                                    containerProps={{ errorMessage: error?.message }}
                                    fieldDefinition={fields.listMap[fieldDefinition.key]}
                                    value={value}
                                    onChange={onChange}
                                    disabled={!isActive}
                                />
                            );
                        }}
                        rules={{
                            validate: getValidationRules({ fieldDefinition })
                        }}
                    />
                );
            })}
        </Space>
    );
};

export default CustomOrganizationFieldsContainer;
